"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _createStyles = require("../styles/createStyles");
const _excluded = ["disableSpacing", "direction", "classes", "className"];
const useStyles = exports.useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.busbud.spacing(2),
      justifyContent: 'flex-end',
      flexDirection: 'row',
      flex: '0 0 auto'
    },
    /* Styles applied to the root element if `disableSpacing={false}`. */
    spacing: {
      '& > :not(:first-child)': {
        marginLeft: theme.busbud.spacing(1)
      }
    },
    /* Styles applied to the root element if `direction="vertical"`. */
    column: {
      paddingTop: theme.busbud.spacing(0),
      paddingBottom: theme.busbud.spacing(2),
      flexDirection: 'column',
      '& > :not(:first-child)': {
        marginLeft: 'unset',
        marginTop: theme.busbud.spacing(2)
      }
    }
  };
});
/**
 * DialogActions is a wrapper used to group action buttons and apply styles to them in a `Dialog` component.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-api-dialogactions--page)
 */
const DialogActions = /*#__PURE__*/_react.default.forwardRef(function DialogActions(props, ref) {
  const {
      disableSpacing = false,
      direction = 'horizontal',
      classes: classesOverrides,
      className
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: cx(classes.root, {
      [classes.spacing]: !disableSpacing,
      [classes.column]: direction !== 'horizontal'
    }, className),
    ref: ref
  }, other));
});
var _default = exports.default = DialogActions;